import { Link, useLocation } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { CompassIcon } from 'lucide-react';
import { ease } from '../../core/format/motion';
import { btnPrimary, btnSecondary } from '../../ui/styles';

/**
 * Een onderdeel van Mijn omgeving dat niet bestaat (oude link uit een mail, typfout).
 * Vroeger stil terug naar de huidreis; nu zeggen we het, en het menu ernaast blijft staan.
 */
export function AccountNotFound() {
  const {
    pathname
  } = useLocation();
  const reduce = useReducedMotion();
  return <motion.section initial={reduce ? false : {
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.24,
    ease
  }} aria-labelledby="account-not-found" className="flex flex-col items-start py-10" data-id="element-5985" data-mp="3tzvujtgmegav">
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-shell text-clay ring-1 ring-line" aria-hidden="true" data-id="element-5986" data-mp="lju2pr5te7kq">
        <CompassIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-5987" data-mp="gr0xz3aciz8n" />
      </span>
      <h1 id="account-not-found" className="mt-5 font-display text-3xl font-light leading-tight text-ink" data-id="element-5988" data-mp="10oebpvfaiezi">
        Dit onderdeel bestaat niet (meer)
      </h1>
      <p className="mt-3 max-w-md text-[15px] leading-relaxed text-muted" data-id="element-5989" data-mp="qyupcfsdc2zw">
        Misschien kwam de link uit een oudere mail. Al je gegevens staan nog gewoon in het menu.
      </p>
      <p className="mt-4 max-w-full truncate font-mono text-[12px] text-muted" data-id="element-5990" data-mp="vvuw6sx1l9s2">
        <span className="sr-only" data-id="element-5991" data-mp="hwlhjxohinq7">Adres: </span>
        {pathname}
      </p>
      <div className="mt-8 flex flex-wrap gap-3" data-id="element-5992" data-mp="m0t69uuy03of">
        <Link to="/account" className={btnPrimary} data-id="element-5993" data-mp="lxf52py0m0ik">
          Naar mijn overzicht
        </Link>
        <Link to="/account/thuis" className={btnSecondary} data-id="element-5994" data-mp="82bmu9c2ldcb">
          Thuis: routine en bestellingen
        </Link>
      </div>
    </motion.section>;
}